<template>
  <div class='order-search'>
    <h2 class='title'>订单查询</h2>
    <div class='wrapper'>
      <div class='header'>
        <div class='header-item' @click='toggleSearchType("GROUP")'>
          <img v-if='searchType === "GROUP"' src='../assets/imgs/selected_on.png' alt='' class='icon'>
          <img v-else src='../assets/imgs/selected_off.png' alt='' class='icon'>
          <span>班级查询</span>
        </div>
        <div class='header-item' @click='toggleSearchType("PERSON")'>
          <img v-if='searchType === "PERSON"' src='../assets/imgs/selected_on.png' alt='' class='icon'>
          <img v-else src='../assets/imgs/selected_off.png' alt='' class='icon'>
          <span>个人查询</span>
        </div>
      </div>

      <!-- 班级查询 -->
      <div v-if='searchType === "GROUP"' class='group-wrapper'>
        <div class='item'>
          <span class='label'>学校<i>*</i>：</span>
          <select v-model='selectedSchool' class='select' @change='selectSchool'>
            <option value='-1' disabled>请选择学校</option>
            <option v-for='(item,index) in schoolOptions' :key='index' :value='item.id'>{{ item.name }}</option>
          </select>
        </div>
        <div class='item'>
          <span class='label'>院系<i>*</i>：</span>
          <select v-model='selectedCollege' class='select' @change='selectCollege' @focus='focusCollege'>
            <option value='-1' disabled>请选择院系</option>
            <option v-for='(item,index) in collegeOptions' :key='index' :value='item.id'>{{ item.name }}</option>
          </select>
        </div>
        <div class='item'>
          <span class='label'>年级-专业班级<i>*</i>：</span>
          <select v-model='selectedCls' class='select' @change='selectCls' @focus='focusCls'>
            <option value='-1' disabled>请选择专业班级</option>
            <option v-for='(item,index) in clsOptions' :key='index' :value='item.id'>{{ item.name }}</option>
          </select>
        </div>
        <div class='item'>
          <span class='label'>批发单号：</span>
          <input v-model='wholesale_no' class='input' type='text' placeholder='请输入批发单号'>
        </div>
        <div class='item'>
          <span class='label'>书号：</span>
          <input v-model='book_no' class='input' type='text' placeholder='请输入书号'>
        </div>
        <div class='btn-wrapper'>
          <a href='javascript:;' class='btn-search' @click='searchOrder'>查询</a>
        </div>
      </div>

      <!-- 个人查询 -->
      <div v-else class='person-wrapper'>
        <div class='item'>
          <span class='label'>姓名<i>*</i>：</span>
          <input v-model='name' class='input' type='text' placeholder='请输入'>
        </div>
        <div class='item'>
          <span class='label'>学号<i>*</i>：</span>
          <input v-model='student_num' class='input' type='text' placeholder='请输入'>
        </div>
        <div class='item'>
          <span class='label'>批发单号：</span>
          <input v-model='wholesale_no' class='input' type='text' placeholder='请输入'>
        </div>
        <div class='item'>
          <span class='label'>书号：</span>
          <input v-model='book_no' class='input' type='text' placeholder='请输入'>
        </div>

        <div class='btn-wrapper'>
          <a href='javascript:;' class='btn-search' @click='searchOrder'>查询</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { SCHOOL_LIST, COLLEGE_LIST, CLS_LIST } from '@/api'

export default {
  data() {
    return {
      selectedSchool: '-1',
      selectedCollege: '-1',
      selectedCls: '-1',
      schoolOptions: [],
      collegeOptions: [],
      clsOptions: [],
      wholesale_no: '',
      book_no: '',
      name: '',
      student_num: ''
    }
  },
  computed: {
    // 团体 or 个人
    searchType() {
      return this.$store.state.searchType
    }
  },

  created() {
    // 获取学校列表
    this.getSchoolList()
    this.setActiveBar('TEXTBOOK')

  },

  methods: {
    // 查询订单
    searchOrder() {
      let flag
      if (this.searchType === 'GROUP') {
        flag = this._validateGroupType()
      } else {
        flag = this._validatePersonType()
      }
      if (!flag) return
            
      this.$store.commit('updateStrData',{key: 'wholesale_no', val: this.wholesale_no})
      this.$store.commit('updateStrData',{key: 'book_no', val: this.book_no})
      this.$store.commit('updateStrData',{key: 'name', val: this.name})
      this.$store.commit('updateStrData',{key: 'student_num', val: this.student_num})
      this.$store.commit('updateStrData',{key: 'searchType', val: this.searchType})
      this.$router.push({ path: '/ordersearchresult' })
    },

    // 表单验证-团体订单
    _validateGroupType() {
      if (this.selectedSchool === '-1') {
        this.$notify('请选择学校','warning')
        return false
      }
      if (this.selectedCollege === '-1') {
        this.$notify('请选择院系','warning')
        return false
      }
      if (this.selectedCls === '-1') {
        this.$notify('请选择班级','warning')
        return false
      }
      return true
    },

    // 表单验证-个人订单
    _validatePersonType() {
      if (!this.name) {
        this.$notify('请输入姓名','warning')
        return false
      }
      if (!this.student_num) {
        this.$notify('请输入学号','warning')
        return false
      }
      return true
    },

    // 切换 团体or个人
    toggleSearchType(val) {
      // 个人查询 需登录账号
      if (val === 'PERSON') {
        if (!this.checkLogin()) {
          this.$notify('请先登录账号','warning')
          this.goRouter('/my')
          return
        }
      }
      let payload = {
        key: 'searchType',
        val
      }
      this.$store.commit('updateStrData',payload)
    },

    // 监听学院获取焦点事件
    focusCollege() {
      if (this.selectedSchool === '-1') {
        this.$notify('请先选择学校','warning')
      }
    },

    // 监听专业班级获取焦点事件
    focusCls() {
      if ((this.selectedSchool === '-1') || (this.selectedCollege === '-1')) {
        this.$notify('请先选择学校/院系','warning')
      }
    },

    // 获取学校
    getSchoolList() {
      SCHOOL_LIST().then(res=>{
        if (res.data.code === 0) {
          this.schoolOptions = res.data.data
          let payload = {
            type: 'SCHOOL',
            list: res.data.data
          }
          this.$store.commit('setSchoolInfoList',payload)
        }
      })
    },

    // 获取院系
    getCollegeList(para) {
      COLLEGE_LIST(para).then(res=>{
        if (res.data.code === 0) {
          this.collegeOptions = res.data.data
          let payload = {
            type: 'COLLEGE',
            list: res.data.data
          }
          this.$store.commit('setSchoolInfoList',payload)
        }
      })
    },

    // 获取班级
    getClsList(para) {
      CLS_LIST(para).then(res=>{
        if (res.data.code === 0) {
          this.clsOptions = res.data.data
          let payload = {
            type: 'CLS',
            list: res.data.data
          }
          this.$store.commit('setSchoolInfoList',payload)
        }
      })
    },

    // 选择学校 -> 获取院系
    selectSchool(e) {
      let para = {
        school_id: e.target.value
      }
      this.collegeOptions = []
      this.clsOptions = []
      this.getCollegeList(para)
      let payload = {
        type: 'SCHOOL',
        item: e.target.value
      }
      this.$store.commit('setSelectedSchoolInfo',payload)
    },

    // 选择院系 -> 获取专业班级
    selectCollege(e) {
      let para = {
        department_id: e.target.value
      }
      this.clsOptions = []
      this.getClsList(para)
      let payload = {
        type: 'COLLEGE',
        item: e.target.value
      }
      this.$store.commit('setSelectedSchoolInfo',payload)
    },

    // 选择班级
    selectCls(e) {
      let payload = {
        type: 'CLS',
        item: e.target.value
      }
      this.$store.commit('setSelectedSchoolInfo',payload)
    }

  },
}
</script>

<style lang="less" scoped>
@import "../assets/css/mixin.less";

.order-search {
  width: 600px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 35px;

  .title {
    font-size: 20px;
    font-weight: 500;
  }
  .wrapper {
    width: 600px;
    height: 465px;
    box-sizing: border-box;
    background: @blue-l;
    border-radius: 15px;
    margin-top: 35px;
    padding: 30px 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);

    .header {
      height: 32px;
      line-height: 32px;
      display: flex;
      flex-direction: row;
      align-content: center;
      justify-content: center;
      margin-bottom: 15px;

      .header-item {
        height: 32px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        margin: 0 15px;
        cursor: pointer;

        .icon {
          margin-right: 15px;
        }
      }
    }

    .person-wrapper,
    .group-wrapper {
      width: 100%;

      .item {
        width: 100%;
        height: 36px;
        line-height: 36px;
        text-align: center;
        font-size: 16px;
        display: flex;
        flex-direction: row;
        align-items: center;
        margin: 10px 0;

        .label {
          display: inline-block;
          width: 200px;
          text-align: end;
          margin-right: 10px;

          i {
            color: red;
          }
        }

        .select {
          box-sizing: border-box;
          display: inline-block;
          width: 300px;
          height: 34px;
          border: 1px solid #dddddd;
          border-radius: 5px;
          background: #ffffff;
          outline: none;
        }

        .input {
          box-sizing: border-box;
          display: inline-block;
          width: 300px;
          height: 34px;
          outline: none;
          border: 1px solid #dddddd;
          border-radius: 5px;
          text-indent: 5px;
        }
      }

      .btn-wrapper {
        height: 38px;
        width: 100%;
        text-align: center;
        margin-top: 40px;

        .btn-search {
          display: inline-block;
          width: 216px;
          height: 38px;
          background-color: @blue-d;
          color: #ffffff;
          font-size: 20px;
          line-height: 38px;
          border-radius: 5px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/OrderSearch.vue